<template>
  <div>
    <img class="pointer" style="width: 100%;" src="@/assets/price/banner.png" @click="$login">
    <div style="padding-top: 150px; text-align: center; display: flex;flex-wrap: wrap;justify-content: space-between;width: 1200px;margin: 0 auto;">
      <div v-for="(item, i) in list" :key="i" style="width: 320px;margin-bottom: 75px;">
        <img :src="item.img">
        <div style="font-size: 15px;font-weight: bold;margin: 25px 0 15px 0;">{{ item.title }}</div>
        <div style="font-size: 12px;color: #999;">{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Price',
  data() {
    return {
      list: [
        {
          title: '邀请他人',
          desc: '邀请你的团队同事或者专业会计参与筝鸣账务管理',
          img: require('@/assets/price/1.png')
        },
        {
          title: '标准报表',
          desc: '标准财务与管理报表',
          img: require('@/assets/price/2.png')
        },
        {
          title: 'Excel插件式报表定制化工具',
          desc: '通过Excel报表定制工具定制化管理报表',
          img: require('@/assets/price/3.png')
        },
        {
          title: '对接银行交易数据',
          desc: '一分钟上传电子银行对账单到系统，完成银行与交易数据对账',
          img: require('@/assets/price/4.png')
        },
        {
          title: '与其他云应用集成',
          desc: '通过标准的API 接口，同步费用与库存管理等其他云业务软件数据',
          img: require('@/assets/price/5.png')
        },
        {
          title: '技术支持',
          desc: '提供丰富的技术参考资料，通过电话，邮件与微信提供技术支持',
          img: require('@/assets/price/6.png')
        },
        {
          title: '软件更新',
          desc: '每月根据客户反馈进行软件功能迭代更新',
          img: require('@/assets/price/7.png')
        },
        {
          title: 'SSL安全加密',
          desc: '周详，严密的安全措施保护您的财务数据',
          img: require('@/assets/price/8.png')
        },
        {
          title: '文档管理',
          desc: '文件存储与管理模块保证您交易支持文档的妥善保存',
          img: require('@/assets/price/9.png')
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
